/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/16/20
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { fetchOrganization } from 'actions/orgCreators';
import { selectOrgById } from 'selectors/entities/organizations';
import EditOrganization from './EditOrganization';

const mapStateToProps = (state, ownProps) => {
  const organization = selectOrgById(state, { orgId: ownProps.match.params.orgId });
  return ({
    organization,
  });
};

const mapStateToDispatch = (dispatch, ownProps) => ({
  fetchOrg: () => dispatch(fetchOrganization(ownProps.match.params.orgId)),
});

export default connect(mapStateToProps, mapStateToDispatch)(EditOrganization);



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/EditOrganization/index.js